import { Grid } from "@mui/material";
import BasicDialog from "../../components/base/BasicDialog";
import { ClientSearchTable } from "../../components/dialog/ClientDiscoveryDialog/ClientSearchTable";

import { useTranslation } from "react-i18next";

export function CustomersFoundDialog(props) {
    const { t } = useTranslation();

    return (
        // @ts-ignore
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("clients.addPersonDialog.customersFounds")}
            maxWidth={"md"}
            showDialogActions
            titleSx={{
                pb: 0,
            }}
        >
            <Grid
                item
                sx={{
                    p: 2,
                    py: 3,
                    bgcolor: "whitesmoke",
                    mt: 2,
                    borderRadius: 2,
                }}
            >
                <ClientSearchTable
                    sx={{
                        borderRadius: 2,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "ButtonFace",
                    }}
                    // @ts-ignore
                    data={props.data || []}
                    readOnly={true}
                />
            </Grid>
        </BasicDialog>
    );
}
